import React from 'react';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Filter from '../../containers/Filter/Filter';
import Filters from '../../containers/Filters/Filters';
import { getPermissions } from '../../utils/getPermissions';

function ContentFilter(props) {
  const {
    auth,
    users,
    contentItems: {
      contentItems: { facet_fields, stats_fields },
    },
  } = props;
  const clientPermissions = getPermissions(auth);

  if (!Object.keys(facet_fields).length) {
    return null;
  }

  // exclude from Lite tier these types: 'folder', 'image', 'sign', 'campaign' (exclude their value too, the next item in the array)
  // e.g. ['sign',4,'video',4,'campaign',2,'folder',2,'playlist',2,'schedule',1,'sequence',1] => ['video',4,'playlist',2,'schedule',1,'sequence',1]
  if (!clientPermissions.atLeastTierPro) {
    const allowedTypes = [];

    for (let i = 0; i < facet_fields.type.length; i += 2) {
      if (!['folder', 'image', 'sign', 'campaign'].includes(facet_fields.type[i])) {
        allowedTypes.push(facet_fields.type[i], facet_fields.type[i + 1]);
      }
    }

    facet_fields.type = allowedTypes;
  }

  const { type, tags, createdBy, modifiedBy } = facet_fields;

  return (
    <Filters>
      <Filter type="text" name="search" title="Search" placeholder="Search content" />
      <Filter type="preset" preset="depth" name="folderDepth" title="Include subfolders" />
      <Filter type="checkbox" name="type" title="Type" data={type} />
      <Filter type="slider" name="width" title="Width" data={stats_fields.width} unit="px" />
      <Filter type="slider" name="height" title="Height" data={stats_fields.height} unit="px" />
      <Filter type="checkbox" name="createdBy" title="Created by" data={createdBy} users={users} />
      <Filter type="preset" name="createdDate" title="Created date" preset="daterange" />
      <Filter
        type="checkbox"
        name="modifiedBy"
        title="Modified by"
        data={modifiedBy}
        users={users}
      />
      <Filter type="preset" name="modifiedDate" title="Modified date" preset="daterange" />
      <Filter type="tag" name="tags" title="Tags" data={tags} />
    </Filters>
  );
}

ContentFilter.propTypes = {
  auth: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  contentItems: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  users: state.users.users,
  contentItems: state.contentItems,
});

export default withRouter(connect(mapStateToProps)(ContentFilter));
